import React, { FC } from 'react';

import { Product } from 'components/product';

import Container from './container';
import { ProductControl } from './styled';
import { IProductListItemProps } from './types';

/**
 * ProductListItem is a component used to display a product in a given list view.
 * It is a container to display a <Product /> component on the left,
 * AND an optional action on the right which could be either -
 * modifier style, favorite/add, carrot to view more.
 */
export const ProductListItem: FC<React.PropsWithChildren<IProductListItemProps>> = ({
  controls,
  isClickable,
  onProductClick,
  onNavigate,
  productProps,
  isHeader,
  accessibilityRole,
  accessibilityLabel,
  accessibilitySelected,
  accessibilityChecked,
}) => {
  return (
    <Container
      isClickable={isClickable}
      onNavigate={onNavigate}
      onProductClick={onProductClick}
      isHeader={isHeader}
      accessibilityRole={accessibilityRole}
      accessibilityLabel={accessibilityLabel}
      accessibilitySelected={accessibilitySelected}
      accessibilityChecked={accessibilityChecked}
    >
      <Product {...productProps} />
      {controls && <ProductControl>{controls}</ProductControl>}
    </Container>
  );
};
